// extracted by mini-css-extract-plugin
export default {"container":"CreateFeedbackUI_container__7YaoH","backLink":"CreateFeedbackUI_backLink__WrqV6","editor":"CreateFeedbackUI_editor__5A6Ea"};